import request from '@/utils/request'

// 获取列表
export function getActivityManList(data) {
  return request({
    url: '/admin/activity/webActivityMan/list',
    method: 'post',
    data
  })
}

// 添加
export function addActivityMan(data) {
  return request({
    url: '/admin/activity/webActivityMan/add',
    method: 'post',
    data
  })
}

// 修改
export function updateActivityMan(data) {
  return request({
    url: '/admin/activity/webActivityMan/edit',
    method: 'post',
    data
  })
}

// 删除
export function removeActivityMan(data) {
  return request({
    url: '/admin/activity/webActivityMan/remove',
    method: 'post',
    data
  })
}
